module.exports = __webpack_public_path__ + "img/symbol_7.c479798a.png";